import { gameAction } from "_actions";
import { GameService } from "_services";
import React, { useEffect, useRef, useState } from "react";
import { Translation } from "react-i18next";
import { connect } from "react-redux";
import { Link, useLocation } from "react-router-dom";
import ProvidersSwiper from "../Casino/ProvidersSwiper";
import PageBanner from "../PageBanner";
import ProvidersMobileSwiper from "../Casino/ProvidersMobileSwiper";
import GridContainer from "../Casino/GridContainer";
import { MdOutlineCasino } from "react-icons/md";
import { PiCoinsBold } from "react-icons/pi";
import BottomNavigation from "../BottomNavigation";
import FilterSearch from "../Casino/FilterSearch";
import FilterTypes from "../Casino/FilterTypes";
import PragmaticGameBox from "../GamerBoxes/PragmaticGameBox";
import MatGameBox from "../GamerBoxes/MatGameBox";
import SmartSoftGameBox from "../GamerBoxes/SmartSoftGameBox";
import BLAS975GameBox from "../GamerBoxes/BLAS975GameBox";
import { useParams } from "react-router-dom";
import WMGameBox from "../GamerBoxes/WMGameBox";
import DetroitBox from "../GamerBoxes/DetroitBox";
import { isBrowser, isMobile, isTablet, isAndroid } from "react-device-detect";
import TimelessTechGameBox from "../GamerBoxes/TimelessTechGameBox";
import BannerCarousel from "../Home/BannerCarousel";
import DigitalOceanSpacesBox from "../GamerBoxes/DigitalOceanSpacesBox";
import Footer from "../Home/Footer";
import InnovaBox from "../GamerBoxes/InnovaBox";
import BannerCarouselV2 from "../Home/BannerCarouselV2";
import GaseaBox from "../GamerBoxes/GaseaBox";
import ProviderSwipeSelector from "../Casino/ProviderSwipeSelector";
import NonameHeroBox from "../GamerBoxes/NonameHeroBox";

const ScrollableListView = (props) => {
  const {
    user,
    loggedIn,
    sports,
    games,
    UpdateSport,
    data,
    pb,
    provider,
    setProvider,
    selectedProviders,
    setSelectedProviders,
    FilterSearchValue,
    setFilterSearchValue,
    title,
  } = props;
  const [FilterTypeValue, setFilterTypeValue] = useState(null);

  const [FilterTypeList, setFilterTypeList] = useState([]);
  const [activeFilterButton, setActiveFilterButton] = useState(0); // 0 = hiçbiri, 1 = buton1, 2 = buton2

  const [loading, setLoading] = useState(false);
  const [lastScrollTop, setLastScrollTop] = useState(0);
  const [isNavVisible, setIsNavVisible] = useState(true);

  const [visibleData, setVisibleData] = useState([]);
  const containerRef = useRef(null);

  const [fabActive, setFabActive] = useState(false);
  const location = useLocation();

  // Scroll pozisyonunu koruma için localStorage key
  const getScrollKey = () => `scroll_position_${location.pathname}`;

  let params = GetParams();

  function GetParams() {
    let params = useParams();
    return params;
  }

  const handleScroll = () => {
    const { scrollTop, clientHeight, scrollHeight } = containerRef.current;

    // Scroll pozisyonunu localStorage'a kaydet (throttle ile)
    if (scrollTop > 0) {
      localStorage.setItem(getScrollKey(), scrollTop.toString());
    }

    if (scrollTop > 300 && !fabActive) {
      setFabActive(true);
      // debugger;
    }
    if (scrollTop < 300 && fabActive) {
      setFabActive(false);
      //    debugger;
    }

    if (scrollTop + clientHeight >= scrollHeight) {
      setVisibleData((prevData) => [
        ...prevData,
        ...data?.slice(prevData.length, prevData.length + 40),
      ]); // Load next 10 items, adjust as needed
    }
    /*
        if (scrollTop > lastScrollTop) {
          setIsNavVisible(false);
        } else {
          setIsNavVisible(true);
        }
        */
    setLastScrollTop(scrollTop <= 0 ? 0 : scrollTop);
  };
  useEffect(() => {
     if (data && data.length > 0) {
      // Scroll pozisyonu varsa, o pozisyona kadar olan item'ları yükle
      const savedScrollPosition = localStorage.getItem(getScrollKey());
      if (savedScrollPosition) {
        const scrollTop = parseInt(savedScrollPosition, 10);
        // Scroll pozisyonuna göre gerekli item sayısını hesapla
        const itemHeight = 200; // Her oyun kartı yaklaşık yüksekliği
        const requiredItems = Math.ceil(scrollTop / itemHeight) + 40; // 40 item buffer ekle
        const itemsToLoad = Math.min(requiredItems, data.length);
        setVisibleData(data.slice(0, itemsToLoad));
      } else {
        // Normal durumda ilk 40 item'ı yükle
        setVisibleData(data.slice(0, 40));
      }
    } else {
      setVisibleData([]);
    }
  }, [data]);

  // Scroll pozisyonunu geri yükle
  useEffect(() => {
    if (containerRef.current && data && data.length > 0) {
      const savedScrollPosition = localStorage.getItem(getScrollKey());
      if (savedScrollPosition) {
        const scrollTop = parseInt(savedScrollPosition, 10);

        // Scroll pozisyonunu ayarla
        const restoreScroll = () => {
          if (containerRef.current) {
            containerRef.current.scrollTop = scrollTop;
          }
        };

        // Önce DOM'un render edilmesini bekle
        const waitForRender = () => {
          // Container'ın yüksekliği hesaplanana kadar bekle
          if (containerRef.current && containerRef.current.scrollHeight > 0) {
            restoreScroll();
          } else {
            // Eğer henüz render edilmemişse, biraz daha bekle
            setTimeout(waitForRender, 10);
          }
        };

        // Hemen dene
        waitForRender();

        // DOM tam yüklendiğinde tekrar ayarla
        setTimeout(restoreScroll, 100);

        // Resimler yüklendiğinde son kez ayarla
        setTimeout(restoreScroll, 300);
      }
    }

    // Cleanup: Component unmount olduğunda scroll pozisyonunu temizle
    return () => {
      // Eski scroll pozisyonlarını temizle (sadece mevcut sayfa değilse)
      const currentPath = location.pathname;
      const scrollKeys = Object.keys(localStorage).filter(key =>
        key.startsWith('scroll_position_') && !key.includes(currentPath)
      );

      // 5'ten fazla scroll pozisyonu varsa eski olanları temizle
      if (scrollKeys.length > 5) {
        scrollKeys.slice(0, scrollKeys.length - 5).forEach(key => {
          localStorage.removeItem(key);
        });
      }
    };
  }, [data, location.pathname]);

  function farkliGameTypeIDListesi(arrayList) {
    // Set oluşturarak benzersiz gameTypeID'leri saklayacağız
    let uniqueGameTypeIDs = new Set();

    // Dizi içinde dolaşarak her bir gameTypeID'yi set'e ekleyeceğiz
    arrayList.forEach(function (item) {
      // Eğer item içinde gameTypeID varsa set'e ekleyeceğiz
      if (item.hasOwnProperty("gameTypeID")) {
        uniqueGameTypeIDs.add(item.gameTypeID + " - " + item.typeDescription);
      }
    });

    // Set'i diziye dönüştürerek farklı gameTypeID'lerin listesini elde ederiz
    return Array.from(uniqueGameTypeIDs);
  }

  const adjustHeight = () => {
    try {
      const navbarHeight = document.querySelector(".base-nav")?.offsetHeight;
      const navbarHeight1 = document.querySelector(".base-nav1")?.offsetHeight;
      const windowHeight = window.innerHeight;

      if (containerRef && containerRef.current) {
        const h =
          windowHeight -
          (navbarHeight > navbarHeight1 ? navbarHeight : navbarHeight1);
        containerRef.current.style.height = `${h}px`;
      }
    } catch (error) { }
  };

  useEffect(() => {
    window.addEventListener("DOMContentLoaded", adjustHeight);
    window.addEventListener("resize", adjustHeight);
  }, []);

  return (
    <Translation>
      {(t) => (
        <>
          <div
            style={{ overflow: "scroll" }}
            ref={containerRef}
            onScroll={handleScroll}
            className="pb-[20px]  overflow-y-scroll"
            onLoad={adjustHeight}


          >
            <PageBanner
              title={title}
              subTitle={t("SUBTITLE_BANNER_CASINO")}
              bg={pb}
            />
            

            <ProviderSwipeSelector
              selectedProviders={selectedProviders}
              setSelectedProviders={setSelectedProviders}
              setProvider={setProvider}
            />


            <section className="mb-1">
              <FilterTypes
                FilterSearchValue={FilterSearchValue}
                setFilterSearchValue={setFilterSearchValue}
                setProvider={setProvider}
                selectedProviders={selectedProviders}
                setSelectedProviders={setSelectedProviders}
                onFilterButtonsChange={setActiveFilterButton}
              />
            </section>
            <div className={`px-1 grid ${
              activeFilterButton === 2 
                ? 'grid-cols-3' 
                : 'grid-cols-2'
            } sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-7 2xl:grid-cols-8 gap-2 md:gap-4`}>
              {visibleData &&
                visibleData.map((item, index) => {
                  if (item._midleware == "norok") {
                    return (
                      <DigitalOceanSpacesBox
                        key={index}
                        isLive={false}
                        index={index}
                        item={item}
                      />
                    );
                  }
                  else if (item._midleware == "matgame") {
                    if (item.is_active == 1) {
                      return (
                        <MatGameBox
                          key={index}
                          isLive={false}
                          index={index}
                          item={item}
                        />
                      );
                    } else {
                      return (<></>);
                    }
                  } else if (item._midleware == "innova") {
                    if (item.enabled == 1) {
                      return (
                        <InnovaBox
                          key={index}
                          isLive={false}
                          index={index}
                          item={item}
                        />
                      );
                    } else {
                      return (<></>);
                    }
                  }else if (item._midleware == "gasea") {
                    return (
                     <GaseaBox
                       key={index}
                       isLive={false}
                       index={index}
                       item={item}
                       vendor={item._midleware}
                     />
                   );
                 } else if (item._midleware == "nonameHero") {
                    return (
                      <NonameHeroBox
                        key={index}
                        index={index}
                        item={item}
                        provider={provider}
                      />
                    );
                  } else {
                    switch (provider) {
                      case "pragmatic":
                        return (
                          <MatGameBox
                            key={index}
                            isLive={false}
                            index={index}
                            item={item}
                          />
                        );
                      case "pragmatic-casino":
                        return (
                          <PragmaticGameBox
                            key={index}
                            isLive={false}
                            index={index}
                            item={item}
                          />
                        );
                      case "smartsoft":
                        return (
                          <SmartSoftGameBox
                            key={index}
                            index={index}
                            item={item}
                          />
                        );
                      case "WorldMatch":
                        return (
                          <WMGameBox
                            key={index}
                            isLive={false}
                            index={index}
                            item={item}
                            provider={provider}
                          />
                        );
                      case "amatic":
                        return (
                          <BLAS975GameBox
                            key={index}
                            index={index}
                            item={item}
                            provider={provider}
                          />
                        );
                      case "novomatic":
                        return (
                          <BLAS975GameBox
                            key={index}
                            index={index}
                            item={item}
                            provider={provider}
                          />
                        );
                      case "bomba":
                        return (
                          <BLAS975GameBox
                            key={index}
                            index={index}
                            item={item}
                            provider={provider}
                          />
                        );
                      case "egt":
                        return (
                          <BLAS975GameBox
                            key={index}
                            index={index}
                            item={item}
                            provider={provider}
                          />
                        );
                      case "netent":
                        return (
                          <BLAS975GameBox
                            key={index}
                            index={index}
                            item={item}
                            provider={provider}
                          />
                        );
                      case "yggdrasil":
                        return (
                          <BLAS975GameBox
                            key={index}
                            index={index}
                            item={item}
                            provider={provider}
                          />
                        );
                      case "playngo":
                        return (
                          <BLAS975GameBox
                            key={index}
                            index={index}
                            item={item}
                            provider={provider}
                          />
                        );
                      case "merkur":
                        return (
                          <BLAS975GameBox
                            key={index}
                            index={index}
                            item={item}
                            provider={provider}
                          />
                        );
                      case "aristocrat":
                        return (
                          <BLAS975GameBox
                            key={index}
                            index={index}
                            item={item}
                            provider={provider}
                          />
                        );
                      case "redtiger":
                        return (
                          <BLAS975GameBox
                            key={index}
                            index={index}
                            item={item}
                            provider={provider}
                          />
                        );
                      case "playtech":
                        return (
                          <BLAS975GameBox
                            key={index}
                            index={index}
                            item={item}
                            provider={provider}
                          />
                        );
                        break;
                      case "iconix":
                        return (
                          <TimelessTechGameBox
                            key={index}
                            index={index}
                            item={item}
                            provider={provider}
                          />
                        );
                        break;

                      default:
                        if (provider.includes("timeless")) {
                          return (
                            <TimelessTechGameBox
                              key={index}
                              index={index}
                              item={item}
                              provider={provider}
                            />
                          );
                        } else if (provider.includes("-fundist")) {
                          return (
                            <WMGameBox
                              key={index}
                              isLive={false}
                              index={index}
                              item={item}
                              provider={provider}
                            />
                          );
                        } else {
                          return (
                            <DetroitBox
                              key={index}
                              index={index}
                              item={item}
                              provider={provider}
                            />
                          );
                        }

                        break;
                    }
                  }


                })}
            </div>
            <Footer />

          </div>
          {fabActive && (
            <button
              className=" btn bg-transparent nav-floating-btn text-white btn-circle fixed right-0 left-0 mx-auto bottom-20 shadow-xl fade-in"
              onClick={() => {
                const scl = containerRef.current;
                scl.scrollTo({
                  top: 0,
                  behavior: "smooth",
                });
              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth={1.5}
                stroke="currentColor"
                className="w-6 h-6"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M4.5 10.5 12 3m0 0 7.5 7.5M12 3v18"
                />
              </svg>
            </button>
          )}




          {props.permissions && (
            <BottomNavigation
            //  permissions={props.permissions}
              isNavVisible={isNavVisible && !loading}
            />
          )}
        </>
      )}
    </Translation>
  );
};

const mapStateToProps = (state, props) => {
  const { authentication, game } = state;
  const { user, loggedIn, permissions } = authentication;
  const { sports, games } = game;
  return {
    user,
    loggedIn,
    sports,
    games,
    permissions,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    UpdateSport: (data) => dispatch(gameAction.UpdateSportsData(data)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ScrollableListView);

const banners = [
  {
    id: 1,
    img: require('../../../assets/img/home/slots.png'),
    gradient: "from-blue-600 to-blue-800",
    path: "/casino"
  },
  {
    id: 2,
    img: require('../../../assets/img/home/livecasino.png'),

    gradient: "from-secondary-600 to-secondary-800",
    path: "/live-casino"
  },
  {
    id: 3,
    img: require('../../../assets/img/home/womensports.png'),

    gradient: "from-green-600 to-green-800",
    path: "/"
  },
  {
    id: 4,
    img: require('../../../assets/img/home/jackpot1.png'),

    gradient: "from-purple-600 to-purple-800",
    path: "/my-account/"
  }
];


export const GetGamePoster = (cat, data) => {
  switch (data._midleware) {
    case "gasea":
      return data.imageLandscape;
    case "innova":
      return data.details.thumbnails['450x345-jpg'];
    case "matgame":
      return data.image;
    case "pragmatic-casino":
      return `https://common-static.ppgames.net/game_pic/square/200/${data.gameID}.png`;
    case "smartsoft":
      return `https://maxbetone.s3.eu-central-1.amazonaws.com/images/smartsoft/${data.GameName}.png`.toLowerCase();
      case "nonameHero":
      return data.image;
    default:
      break;
  }
};


export const GameProviders = [
  {
    name: "pragmatic.png",
    value: "pragmatic",
  },
  {
    name: "wm.png",
    value: "WorldMatch-fundist",
  },

  {
    name: "card-02.png",
    value: "amatic",
  },
  {
    name: "card-03.png",
    value: "novomatic",
  },
  {
    name: "card-04.png",
    value: "bomba",
  },
  {
    name: "card-05.png",
    value: "egt",
  },
  {
    name: "card-06.png",
    value: "netent",
  },
  {
    name: "card-07.png",
    value: "yggdrasil",
  },

  {
    name: "card-09.png",
    value: "playngo",
  },

  {
    name: "card-10.png",
    value: "aristocrat",
  },
  {
    name: "card-11.png",
    value: "redtiger",
  },
  {
    name: "card-12.png",
    value: "playtech",
  },
  {
    name: "1x2.png",
    value: "1X2_GAMING",
  },

  {
    name: "evoplay.png",
    value: "EVOPLAY",
  },

  {
    name: "igt.png",
    value: "IGT",
  },

  {
    name: "playson.png",
    value: "PLAYSON",
  },

  {
    name: "booongo.png",
    value: "BOOONGO",
  },
  {
    name: "wazdan.png",
    value: "WAZDAN",
  },

  {
    name: "rubyplay.png",
    value: "RUBYPLAY",
  },

  {
    name: "microgaming.png",
    value: "MICROGAMING",
  },

  {
    name: "betsoft.png",
    value: "BETSOFT",
  },

  {
    name: "octavian.png",
    value: "OCTAVIAN",
  },
  {
    name: "timeless/tv_bet_final_logo_w.png",
    value: "TVBet-fundist",
  },
  {
    name: "fundist/atmosfera-logo.png",
    value: "Atmosfera-fundist",
  },
  {
    name: "fundist/XPG-transparent.png",
    value: "XProGaming-fundist",
  },
  {
    name: "fundist/lucky-streak.png",
    value: "LuckyStreak-fundist",
  },
  {
    name: "fundist/ae-sexy-logo.png",
    value: "AESexyBaccarat-fundist",
  },
  {
    name: "fundist/evoplay_logo.png",
    value: "Evoplay-fundist",
  },
  {
    name: "not.png",
    value: "Redgenn-fundist",
  },
  {
    name: "fundist/wm_logo-440x155.png",
    value: "WMCasino-fundist",
  },
  {
    name: "timeless/SMARSOFT_LOGO_White.png",
    value: "SmartSoft-fundist",
  },
  {
    name: "fundist/Upgaming_m.jpg",
    value: "Upgaming-fundist",
  },
  {
    name: "TomHorn.png",
    value: "Tom Horn-fundist",
  },
  {
    name: "LiveGames_logo_white.png",
    value: "LiveGames-fundist",
  },
  {
    name: "fundist/GameArt_m.jpg",
    value: "GameArt-fundist",
  },
  {
    name: "evolution_gaming.png",
    value: "Evolution-fundist",
  },
  {
    name: "AG_logo_white_hori.png",
    value: "AsiaGamingSlots-fundist",
  },
  {
    name: "TurboGames_logo_white.png",
    value: "TurboGames-fundist",
  },
  {
    name: "BetSolutions_logo_white.png",
    value: "BetSoft-fundist",
  },
  {
    name: "BGaming_logo_bw.png",
    value: "BGaming-fundist",
  },
  {
    name: "fundist/novomatic-1-line-logo-white.png",
    value: "Novomatic-fundist",
  },
  {
    name: "fundist/spribe-black.png",
    value: "Spribe-fundist",
  },

  {
    name: "scientific_games.png",
    value: "SCIENTIFIC_GAMES",
  },
  { name: "timeless/3Oaks_logo_w.png", value: "3oaks-timelesstech" },
  { name: "timeless/3Oaks_logo_white.png", value: "3oaksP-timelesstech" },
  {
    name: "timeless/TurboGames_logo_white.png",
    value: "turbo-games-timelesstech",
  },
  { name: "timeless/Playson_logo-w.png", value: "play-son-timelesstech" },
  { name: "timeless/Playson_logo-white.png", value: "play-sonP-timelesstech" },
  { name: "timeless/7777_logo_w.png", value: "7777-timelesstech" },
  {
    name: "timeless/Iconix_Interactive_logo-01.png",
    value: "iconix-timelesstech",
  },
  { name: "timeless/RocketMan_logo.png", value: "rocketman-timelesstech" },
  { name: "timeless/KAg_logo_w.png", value: "kagaming-timelesstech" },
  { name: "timeless/Netend_logo_white.png", value: "net ent P-timelesstech" },
  { name: "timeless/EvoPlay_logo_w.png", value: "evoplay-timelesstech" },
  { name: "timeless/Habanero_Logo_w.png", value: "habanero-timelesstech" },
  {
    name: "timeless/Galaxsys_logo-blue-RGB-01.png",
    value: "galaxsys-timelesstech",
  },
  {
    name: "timeless/CT_Interactive_logo_green.png",
    value: "ctinteractive-timelesstech",
  },
  { name: "timeless/Mancala_logo_white.png", value: "mancala-timelesstech" },
  { name: "timeless/retrobet.png", value: "retrogames-timelesstech" },
  { name: "timeless/Spinomenal_logo.png", value: "spinomenal-timelesstech" },
  { name: "timeless/Platipus_white.png", value: "platipus-timelesstech" },
  { name: "timeless/FG_bw.png", value: "fils-timelesstech" },
  { name: "timeless/BF_GAMES_LOGO_w.png", value: "bfgames-timelesstech" },
  { name: "timeless/PopOk_Vector_02.png", value: "popok-timelesstech" },
  { name: "timeless/JetX_logo.png", value: "jetx-timelesstech" },
  { name: "timeless/SMARSOFT_LOGO_White.png", value: "smartsoft-timelesstech" },
  { name: "timeless/PGSoft_logo_white.png", value: "pgsoft-timelesstech" },
  {
    name: "timeless/PlatinGaming_white.png",
    value: "platingaming-timelesstech",
  },
  {
    name: "timeless/Endorphina_Logo_White_Text.png",
    value: "endorphina-timelesstech",
  },
  { name: "timeless/SkyWindGroup_Logo2021.png", value: "skywind-timelesstech" },
  { name: "timeless/7mojos_logo.png", value: "7-mojos-slots-timelesstech" },

  { name: "timeless/EAGaming_logo.png", value: "eagaming-timelesstech" },
  { name: "timeless/big_time.svg", value: "bigtimegaming-timelesstech" },
  { name: "timeless/netgame.png", value: "netgame-timelesstech" },
  { name: "timeless/Aviator_logo_1.png", value: "aviator-timelesstech" },
  { name: "timeless/Spribe.png", value: "spribe-timelesstech" },
  { name: "timeless/RedTiger_Red2.png", value: "red tiger P-timelesstech" },
  { name: "timeless/RedTiger_White2.png", value: "red tiger-timelesstech" },
  { name: "timeless/Netend_logo_white.png", value: "net ent-timelesstech" },
  { name: "timeless/NolimitCity_white.png", value: "nolimitcity-timelesstech" },
  {
    name: "timeless/MacawGamingTextLogoWhite.png",
    value: "macaw-timelesstech",
  },
  { name: "timeless/Booming.png", value: "booming-timelesstech" },
];

/*
  { name: "timeless/PP_Logo_On.png", value: "pragmatic-timelesstech" },
  { name: "timeless/PP_Logo_On.png", value: "pragmaticS-timelesstech" },

*/

/**
 
VİRTUAL E GEÇTİ TAMAMEN

 {
    name: "virtual.png",
    value: "VIRTUAL",
  },
    {
    name: "racing.png",
    value: "RACING",
  },

 */

/*
KALDIRILAN SAĞLAYICILAR

{
    {
    name: "merkur.svg",
    value: "merkur",
  },
   {
    name: "booming_games.png",
    value: "BOOMING_GAMES",
  },

    {
    name: "big_time_gaming.png",
    value: "BIG_TIME_GAMING",
  },
    {
    name: "leap.png",
    value: "LEAP",
  },
    name: "gaminator.png",
    value: "GAMINATOR",
  },
   {
    name: "platipus.png",
    value: "PLATIPUS",
  },
   {
    name: "merkur.png",
    value: "MERKUR",
  },
  {
    name: "red_rake.png",
    value: "RED_RAKE",
  },
  {
    name: "apex.png",
    value: "APEX",
  }
   {
    name: "quickspin.png",
    value: "QUICKSPIN",
  }, 
 
  {
    name: "ainsworth.png",
    value: "AINSWORTH",
  },
  {
    name: "firekirin.png",
    value: "FIREKIRIN",
  },
  {
    name: "apollo_games.png",
    value: "APOLLO_GAMES",
  },
  {
    name: "kajot.png",
    value: "KAJOT",
  },
  {
    name: "gameart.png",
    value: "GAMEART",
  },{
    name: "habanero.png",
    value: "HABANERO",
  },  {
    name: "isoftbet.png",
    value: "ISOFTBET",
  }, 
   {
    name: "skywind.png",
    value: "SKYWIND",
  },
    
   {
    name: "spinomenal.png",
    value: "SPINOMENAL",
  },
 {
    name: "iron_dog.png",
    value: "IRON_DOG",
  },
 {
    name: "igrosoft.png",
    value: "IGROSOFT",
  },*/

/*  {
    name: "xplosive.png",
    value: "XPLOSIVE",
  },
{
    name: "zeus_play.png",
    value: "ZEUS_PLAY",
  }
  */

/*
GAMES TARAFINA TRANSFER EDİLDİ

 {
    name: "super_keno.png",
    value: "SUPER_KENO",
  },
  {
    name: "spribe.png",
    value: "SPRIBE",
  },

*/



{/*
        
            {isMobile || isTablet || isAndroid ? (
              <section className=" py-2 ">
                <ProvidersMobileSwiper
                  provider={provider}
                  _data={[
                    ...GameProviders.filter((x) => {
                      if (
                        x.value == "WorldMatch" &&
                        !props?.permissions?.WM?.Value
                      ) {
                        return false;
                      } else if (
                        x.value == "pragmatic-casino" &&
                        !props?.permissions?.PRAGMATIC_CASINO_ACCESS?.Value
                      ) {
                        return false;
                      } else if (
                        x.value == "amatic" &&
                        !props?.permissions?.AMATIC_CASINO_ACCESS?.Value
                      ) {
                        return false;
                      } else if (
                        x.value == "novomatic" &&
                        !props?.permissions?.NOVOMATIC_CASINO_ACCESS?.Value
                      ) {
                        return false;
                      } else if (
                        x.value == "bomba" &&
                        !props?.permissions?.BOMBA_CASINO_ACCESS?.Value
                      ) {
                        return false;
                      } else if (
                        x.value == "egt" &&
                        !props?.permissions?.EGT_CASINO_ACCESS?.Value
                      ) {
                        return false;
                      } else if (
                        x.value == "netent" &&
                        !props?.permissions?.NETENT_CASINO_ACCESS?.Value
                      ) {
                        return false;
                      } else if (
                        x.value == "yggdrasil" &&
                        !props?.permissions?.YGGDRASIL_CASINO_ACCESS?.Value
                      ) {
                        return false;
                      } else if (
                        x.value == "playngo" &&
                        !props?.permissions?.PLAYNGO_CASINO_ACCESS?.Value
                      ) {
                        return false;
                      } else if (
                        x.value == "aristocrat" &&
                        !props?.permissions?.ARISTOCRAT_CASINO_ACCESS?.Value
                      ) {
                        return false;
                      } else if (
                        x.value == "redtiger" &&
                        !props?.permissions?.REDTIGER_CASINO_ACCESS?.Value
                      ) {
                        return false;
                      } else if (
                        x.value == "playtech" &&
                        !props?.permissions?.PLAYTECH_CASINO_ACCESS?.Value
                      ) {
                        return false;
                      } else if (
                        x.value == "1X2_GAMING" &&
                        !props?.permissions?.X12_GAMING_CASINO_ACCESS?.Value
                      ) {
                        return false;
                      } else if (
                        x.value == "EVOPLAY" &&
                        !props?.permissions?.EVOPLAY_CASINO_ACCESS?.Value
                      ) {
                        return false;
                      } else if (
                        x.value == "IGT" &&
                        !props?.permissions?.IGT_CASINO_ACCESS?.Value
                      ) {
                        return false;
                      } else if (
                        x.value == "PLAYSON" &&
                        !props?.permissions?.PLAYSON_CASINO_ACCESS?.Value
                      ) {
                        return false;
                      } else if (
                        x.value == "BOOONGO" &&
                        !props?.permissions?.BOOONGO_CASINO_ACCESS?.Value
                      ) {
                        return false;
                      } else if (
                        x.value == "WAZDAN" &&
                        !props?.permissions?.WAZDAN_CASINO_ACCESS?.Value
                      ) {
                        return false;
                      } else if (
                        x.value == "RUBYPLAY" &&
                        !props?.permissions?.RUBYPLAY_CASINO_ACCESS?.Value
                      ) {
                        return false;
                      } else if (
                        x.value == "MICROGAMING" &&
                        !props?.permissions?.MICROGAMING_CASINO_ACCESS?.Value
                      ) {
                        return false;
                      } else if (
                        x.value == "BETSOFT" &&
                        !props?.permissions?.BETSOFT_CASINO_ACCESS?.Value
                      ) {
                        return false;
                      } else if (
                        x.value == "OCTAVIAN" &&
                        !props?.permissions?.OCTAVIAN_CASINO_ACCESS?.Value
                      ) {
                        return false;
                      } else if (
                        x.value == "SCIENTIFIC_GAMES" &&
                        !props?.permissions?.SCIENTIFIC_GAMES_CASINO_ACCESS
                          ?.Value
                      ) {
                        return false;
                      } else return true;
                    }),
                  ].filter((x) => games && games.hasOwnProperty(x.value))}
                />
              </section>
            ) : (
              <section className="py-2 mobile-hide">
                <ProvidersSwiper
                  provider={provider}
                  _data={[
                    ...GameProviders.filter((x) => {
                      if (
                        x.value == "WorldMatch" &&
                        !props?.permissions?.WM?.Value
                      ) {
                        return false;
                      } else if (
                        x.value == "pragmatic-casino" &&
                        !props?.permissions?.PRAGMATIC_CASINO_ACCESS?.Value
                      ) {
                        return false;
                      } else if (
                        x.value == "amatic" &&
                        !props?.permissions?.AMATIC_CASINO_ACCESS?.Value
                      ) {
                        return false;
                      } else if (
                        x.value == "novomatic" &&
                        !props?.permissions?.NOVOMATIC_CASINO_ACCESS?.Value
                      ) {
                        return false;
                      } else if (
                        x.value == "bomba" &&
                        !props?.permissions?.BOMBA_CASINO_ACCESS?.Value
                      ) {
                        return false;
                      } else if (
                        x.value == "egt" &&
                        !props?.permissions?.EGT_CASINO_ACCESS?.Value
                      ) {
                        return false;
                      } else if (
                        x.value == "netent" &&
                        !props?.permissions?.NETENT_CASINO_ACCESS?.Value
                      ) {
                        return false;
                      } else if (
                        x.value == "yggdrasil" &&
                        !props?.permissions?.YGGDRASIL_CASINO_ACCESS?.Value
                      ) {
                        return false;
                      } else if (
                        x.value == "playngo" &&
                        !props?.permissions?.PLAYNGO_CASINO_ACCESS?.Value
                      ) {
                        return false;
                      } else if (
                        x.value == "aristocrat" &&
                        !props?.permissions?.ARISTOCRAT_CASINO_ACCESS?.Value
                      ) {
                        return false;
                      } else if (
                        x.value == "redtiger" &&
                        !props?.permissions?.REDTIGER_CASINO_ACCESS?.Value
                      ) {
                        return false;
                      } else if (
                        x.value == "playtech" &&
                        !props?.permissions?.PLAYTECH_CASINO_ACCESS?.Value
                      ) {
                        return false;
                      } else if (
                        x.value == "1X2_GAMING" &&
                        !props?.permissions?.X12_GAMING_CASINO_ACCESS?.Value
                      ) {
                        return false;
                      } else if (
                        x.value == "EVOPLAY" &&
                        !props?.permissions?.EVOPLAY_CASINO_ACCESS?.Value
                      ) {
                        return false;
                      } else if (
                        x.value == "IGT" &&
                        !props?.permissions?.IGT_CASINO_ACCESS?.Value
                      ) {
                        return false;
                      } else if (
                        x.value == "PLAYSON" &&
                        !props?.permissions?.PLAYSON_CASINO_ACCESS?.Value
                      ) {
                        return false;
                      } else if (
                        x.value == "BOOONGO" &&
                        !props?.permissions?.BOOONGO_CASINO_ACCESS?.Value
                      ) {
                        return false;
                      } else if (
                        x.value == "WAZDAN" &&
                        !props?.permissions?.WAZDAN_CASINO_ACCESS?.Value
                      ) {
                        return false;
                      } else if (
                        x.value == "RUBYPLAY" &&
                        !props?.permissions?.RUBYPLAY_CASINO_ACCESS?.Value
                      ) {
                        return false;
                      } else if (
                        x.value == "MICROGAMING" &&
                        !props?.permissions?.MICROGAMING_CASINO_ACCESS?.Value
                      ) {
                        return false;
                      } else if (
                        x.value == "BETSOFT" &&
                        !props?.permissions?.BETSOFT_CASINO_ACCESS?.Value
                      ) {
                        return false;
                      } else if (
                        x.value == "OCTAVIAN" &&
                        !props?.permissions?.OCTAVIAN_CASINO_ACCESS?.Value
                      ) {
                        return false;
                      } else if (
                        x.value == "SCIENTIFIC_GAMES" &&
                        !props?.permissions?.SCIENTIFIC_GAMES_CASINO_ACCESS
                          ?.Value
                      ) {
                        return false;
                      } else return true;
                    }),
                  ].filter((x) => games && games.hasOwnProperty(x.value))}
                />
              </section>
            )}


        */}